EVERFLOW_TRACKING_VARS